import React from "react";
import { ESearchWizardSteps } from "../../../shared/enums/search.enums";
import { DefaultOutageSearchProps, IOutageSearchProps } from "../Form.types";
import OUTAGE_SEARCH_FORM from "./views/SearchForm.component";
import OUTAGE_SEARCH_RESULTS from "./views/SearchResults.component";

const OUTAGE_SEARCH: React.FC<IOutageSearchProps> = (
  props: IOutageSearchProps
) => {
  const { activeView, onClose } = props;

  let currentView;
  switch (activeView) {
    case ESearchWizardSteps.SEARCH:
      currentView = <OUTAGE_SEARCH_FORM onClose={onClose} />;
      break;
    case ESearchWizardSteps.RESULTS:
      currentView = <OUTAGE_SEARCH_RESULTS onClose={onClose} />;
      break;

    default:
      currentView = <OUTAGE_SEARCH_FORM onClose={onClose} />;
      break;
  }

  return currentView;
};

OUTAGE_SEARCH.defaultProps = DefaultOutageSearchProps;
export default OUTAGE_SEARCH;
